import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  autoHideDuration: 3000,
  snackbarMessage: '',
  snackbarOpen: false,
  snackbarType: 'info',
  sidebarOpen: true,
  openList: false,
};

const uiReducer = createReducer(initialState)({
  [types.UI_SHOW_SNACKBAR]: (state, { payload }) => {
    return {
      ...state,
      snackbarOpen: true,
      snackbarType: payload.type,
      snackbarMessage: payload.message,
      autoHideDuration: payload.hasOwnProperty('autoHideDuration')
        ? payload?.autoHideDuration
        : 3000,
    };
  },
  [types.UI_SNACKBAR_CLEAR]: (state) => {
    return {
      ...state,
      snackbarOpen: false,
    };
  },
  [types.UI_SHOW_SIDEBAR]: (state, { payload }) => {
    return {
      ...state,
      sidebarOpen: payload.open,
    };
  },
  [types.UI_SHOW_LIST]: (state, { payload }) => {
    return {
      ...state,
      openList: payload.open,
    };
  },
});

export default uiReducer;
